"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./src/animators/animator.ts
// module id = 80
// module chunks = 0